import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'components/ui-components/Button';
import Card from 'components/ui-components/Card';
import HookFormTextInput from 'components/cef_form/hook-form/HookFormTextInput';
import HookFormSelect from 'components/cef_form/hook-form/HookFormSelect';
import { HookFormProvider } from 'components/cef_form/hook-form/providers/HookFormProvider';
import AccountChangeRequestModal from './account_change_request_modal';

const UserDetails = ({ label, value }) => (
  <>
    <p className="cef-ui-input-label__title fs-14 fw-500 mb-8">{label}</p>
    <p className="tc-secondary mb-24">{value}</p>
  </>
);

const AccountChangeRequestForm = ({ formValues }) => {
  const [accountDeletionData, setAccountDeletionData] = useState(formValues);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const {
    control,
    handleSubmit,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      telephone: '',
      requestReason: '',
    },
  });

  const {
    full_name: fullName,
    contact_email: contactEmail,
    address,
  } = formValues;

  const openConfirmationModel = () => {
    const { telephone, requestReason } = watch();
    setAccountDeletionData({
      ...formValues,
      telephone,
      request_reason: requestReason,
    });
    setModalIsOpen(true);
  };

  return (
    <HookFormProvider
      control={control}
      trigger={trigger}
      watch={watch}
      errors={errors}>
      <form onSubmit={handleSubmit(openConfirmationModel)}>
        <Card variant="small" className="mb-32">
          <UserDetails label="Full Name" value={fullName} />
          <UserDetails label="Contact Email" value={contactEmail} />
          <UserDetails label="Contact Address" value={address} />

          <div className="mb-24">
            <HookFormTextInput
              variant="small"
              type="tel"
              id="telephone"
              label={
                'Telephone <span className="fw-400 fs-12">(Optional)</span>'
              }
            />
          </div>

          <HookFormSelect
            variant="small"
            id="requestReason"
            label="Please tell us why you wish to delete your account"
            placeholder="Select an option"
            selectItems={[
              {
                label: 'I have another account',
                value: 'I have another account',
              },
              {
                label: 'I was added to another account as a user',
                value: 'I was added to another account as a user',
              },
              {
                label: 'I have had issues with my account',
                value: 'I have had issues with my account',
              },
              {
                label: 'I no longer shop at CEF',
                value: 'I no longer shop at CEF',
              },
              {
                label: "I'm no longer interested in your products",
                value: "I'm no longer interested in your products",
              },
              {
                label: "I'm not happy with your service",
                value: "I'm not happy with your service",
              },
              { label: 'Other', value: 'Other' },
            ]}
            rules={{
              required: 'Please select an option',
            }}
          />
        </Card>

        <div className="actions fl sm-fl-col m-fl-row jc-fs ai-c">
          <Button
            type="submit"
            className="cef-btn cef-btn--red cef-btn--feature">
            Request Trade Account Deletion
          </Button>

          <a
            href="/mycef/account/edit"
            className="fl ai-c td-u fs-18 tc-grey-60 cef-btn--high mt-24 m-mt-0 m-ml-24">
            Cancel
          </a>
        </div>
      </form>

      <AccountChangeRequestModal
        modalIsOpen={modalIsOpen}
        closeModal={() => setModalIsOpen(false)}
        accountDeletionData={accountDeletionData}
      />
    </HookFormProvider>
  );
};

export default AccountChangeRequestForm;
